(() => {
  'use strict';
  if(window.FCSProductFitMobile)return;
  const media=window.matchMedia('(max-width:700px)'),states=new Map();
  function apply(s){
    if(s.mobile===media.matches)return;
    s.mobile=media.matches;
    if(s.mobile){
      s.desktopOpen=s.details.dataset.fcsEnclosureConfiguration==='true'?s.details.dataset.fcsEnclosureOriginalOpen==='true':s.details.open;s.details.open=s.details.dataset.fcsEnclosureConfiguration==='true';
      s.controls.forEach(({node})=>s.tools.append(node));s.details.append(s.tools);
    }else{
      s.controls.forEach(({node,anchor})=>anchor.after(node));s.tools.remove();s.details.open=s.details.dataset.fcsEnclosureConfiguration==='true'||s.desktopOpen;
    }
  }
  function scan(){
    document.querySelectorAll('[data-fcs-live-product-panel]').forEach(panel=>{
      if(states.has(panel))return;
      const details=panel.querySelector('.fcs-live-installation');if(!details)return;
      const controls=[...panel.children].filter(node=>node.matches('[data-fcs-retry-fit],[data-fcs-fitment-feedback]')).map(node=>{
        const anchor=document.createComment('Fitment control desktop position');node.before(anchor);return{node,anchor};
      });
      const tools=document.createElement('div');tools.className='fcs-mobile-fit-tools';
      const s={panel,details,tools,controls,mobile:null,desktopOpen:details.open};states.set(panel,s);apply(s);
    });
    for(const [panel]of states)if(!panel.isConnected)states.delete(panel);
  }
  function start(){scan();new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-fcs-live-product-panel]')||n.querySelector?.('[data-fcs-live-product-panel]')))))scan();}).observe(document.body,{childList:true,subtree:true});}
  media.addEventListener('change',()=>{scan();states.forEach(apply);});
  window.FCSProductFitMobile={refresh:scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
